import { use } from 'react'
import { useHorizontalScroll } from '../../composables/use-horizontal-scroll'
import { ThemeContext } from '../ThemeContext'

export type StampRallyItem = {
  id: string
  name: string
}

type ButtonProps = {
  isActive: boolean
} & React.ComponentProps<'button'>

function Button({ isActive, ...props }: ButtonProps) {
  const { mainColor } = use(ThemeContext)
  return (
    <button
      type="button"
      className="shrink-0 grow-0 rounded-full px-2 py-1 text-center text-xs"
      style={{ backgroundColor: isActive ? mainColor : '#fff' }}
      {...props}
    />
  )
}

type StampRallyLabelsProps = {
  activeStampRallyId?: string
  stampRallies: StampRallyItem[]
  onClick: (stampRallyId: string) => void
}

export function StampRallyLabels({ activeStampRallyId, stampRallies, onClick }: StampRallyLabelsProps) {
  const { scrollRef, isDragging, handleMouseDown, handleMouseLeave, handleMouseUp, handleMouseMove, handleClick } = useHorizontalScroll()

  return (
    <div
      className="flex select-none gap-2 overflow-x-auto [&::-webkit-scrollbar]:hidden [&::-webkit-scrollbar]:bg-transparent"
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      onClick={handleClick}
      ref={scrollRef}
    >
      {stampRallies.map(item => (
        <Button
          key={item.id}
          isActive={activeStampRallyId === item.id}
          onClick={(e) => {
            if (!isDragging) {
              onClick(item.id)
              e.stopPropagation()
            }
          }}
        >
          {item.name}
        </Button>
      ))}
    </div>
  )
}
